/**
 * HR org-unit structure CRUD over /api/v1/hr/org-units.
 *
 * Backs the org-chart "Edit structure" mode. HR / Director / Exec Director
 * only — 403/404 from the API bubble up as ApiError. Structural only; does
 * not touch approver routing.
 */
import {
  type OrgChartUnit,
  orgChartUnitSchema,
  type OrgUnitType,
} from '@lms/shared-types'
import { apiRequest } from './client'

export interface CreateOrgUnitPayload {
  parentId: string | null
  unitType: OrgUnitType
  name: string
  headEmployeeId?: string | null
}

export async function createOrgUnit(
  payload: CreateOrgUnitPayload,
): Promise<OrgChartUnit> {
  const raw = await apiRequest<OrgChartUnit>('/api/v1/hr/org-units', {
    method: 'POST',
    body: payload,
  })
  return orgChartUnitSchema.parse(raw)
}

export interface UpdateOrgUnitPayload {
  name?: string
  unitType?: OrgUnitType
  /** Move: new parent unit id. */
  parentId?: string | null
  /** Set/clear the unit head. */
  headEmployeeId?: string | null
}

export async function updateOrgUnit(
  unitId: string,
  payload: UpdateOrgUnitPayload,
): Promise<OrgChartUnit> {
  const raw = await apiRequest<OrgChartUnit>(
    `/api/v1/hr/org-units/${unitId}`,
    { method: 'PATCH', body: payload },
  )
  return orgChartUnitSchema.parse(raw)
}

export async function deleteOrgUnit(unitId: string): Promise<void> {
  await apiRequest<null>(`/api/v1/hr/org-units/${unitId}`, {
    method: 'DELETE',
  })
}
